module.exports = __webpack_public_path__ + "static/media/logo.b37032db.png";